import { call, put } from 'redux-saga/effects';

import { IUserProfileResponse } from 'api/components/User/types';
import api from 'api';

import {
    getCurrentUserError,
    getCurrentUserRequest,
    getCurrentUserSuccess,
    postGoogleAnalyticsId,
    setUserAbTestPercentage,
} from 'store/user/actions';
import { notifyError } from 'store/notifications/actions';

import { getUserPercentForABTest } from 'services/Firebase/utils/getUserPercentForABTest';
import { setEppoDefaultAttributes } from 'services/Eppo';
import { setDatadogRumUser } from 'services/DataDog';
import { setIdToTheProvider } from 'services/Analytics/helpers';

import { userAPIResponseTransformer } from 'helpers/api';
import { waitForGetUserWebAnalytics } from './helpers';

export function* getCurrentUser({ payload }: ReturnType<typeof getCurrentUserRequest>) {
    const { onSuccess, onError } = payload ?? {};

    try {
        const userData: IUserProfileResponse = yield call(api.user.getUser);

        yield call(waitForGetUserWebAnalytics);

        yield call(setIdToTheProvider, userData.id);

        yield call(setDatadogRumUser, userData.id);

        yield put(postGoogleAnalyticsId());

        yield put(getCurrentUserSuccess(userAPIResponseTransformer(userData)));

        yield call(setEppoDefaultAttributes);

        const abTestPercentage: number = yield call(getUserPercentForABTest, userData.user_id);

        yield put(setUserAbTestPercentage(abTestPercentage));

        if (onSuccess) yield call(onSuccess, userData);
    } catch (error: any) {
        yield put(getCurrentUserError());
        yield put(notifyError({ message: 'message.error.somethingWentWrong' }));

        if (onError) yield call(onError, error);
    }
}
